import { useQuery } from 'react-query';

import { STALE_TIME } from '@savgroup-front-common/constants';
import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';
import { PaymentService } from '@/api';

const GetPaymentAccountForContextQuery = 'getPaymentAccountForContextQuery';

export const useGetPaymentAccount = ({
  claimGroupId,
  shouldToastError = true,
  isEnabled = true,
}: {
  claimGroupId: string;
  shouldToastError?: boolean;
  isEnabled?: boolean;
}) => {
  const { pushErrors } = useToasts();

  const { data: paymentAccountDto } = useQuery(
    [GetPaymentAccountForContextQuery, claimGroupId],
    async () => {
      const response = await PaymentService.getPaymentAccountForContextQuery({
        claimGroupId,
      });

      if (response.failure) {
        if (shouldToastError) {
          pushErrors(response.errors);
        }

        return undefined;
      }

      return response.value;
    },
    {
      staleTime: STALE_TIME.SECONDS_5,
      suspense: true,
      enabled: isEnabled,
    },
  );

  return { paymentAccountDto };
};
